import { render, staticRenderFns } from "./search-normal-1.vue?vue&type=template&id=ddf5aa22&"
import script from "./search-normal-1.vue?vue&type=script&lang=js&"
export * from "./search-normal-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports